module.exports = __webpack_public_path__ + "static/logo_bsd-dark-2494e17d28a8cb4bf752adb24904fa4b.png";